import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({ key: "adsState" });

export const ActiveAdAtom = atom({
  key: "activeAd_v0",
  default: "",
});

export const ClipsCreatedAtom = atom({
  key: "clipsCreated",
  default: 0,
  effects_UNSTABLE: [persistAtom],
});
